import { FilingFormState } from '../filing-form-state.service';
import { SheetProjector, SheetProjectionContext } from '../sheet-projector';
import { ConditionalControl } from '../conditional/conditional-field.model';
import { projectVisibleData } from '../conditional/conditional-field.evaluator';

/**
 * Build a pure {@link SheetProjector} from a sheet's control list. The projector
 * strips every field hidden by a `visibility`/`both` conditional rule, using the
 * shared `projectVisibleData` evaluator — the SAME interpretation the rendering
 * component uses, so the two cannot drift. Controls with no `conditional` block
 * are pre-filtered so per-submit work is proportional to the conditional fields.
 */
export function makeSchemaProjector(sheetKey: keyof FilingFormState, controls: ConditionalControl[]): SheetProjector {
  const conditionalControls = controls.filter((control) => !!control.conditional);
  return {
    sheetKey,
    project(sheetData: Record<string, any>, context?: SheetProjectionContext): Record<string, any> {
      return projectVisibleData(conditionalControls, sheetData, context);
    },
  };
}
